import React from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function NoPermissionAlert({ requiredRole, currentRole }) {
    const navigate = useNavigate();

    return (
        <Container className="py-5">
            <Alert variant="warning" className="mt-4">
                <Alert.Heading>접근 권한이 없습니다</Alert.Heading>
                <p>
                    이 기능을 사용하기 위해서는 {requiredRole} 이상의 권한이 필요합니다.
                    현재 귀하의 권한은 {currentRole} 입니다.
                </p>
                <hr />
                <div className="d-flex justify-content-between">
                    <Button variant="outline-warning" onClick={() => navigate(-1)}>
                        이전 페이지로
                    </Button>
                    <Button variant="warning" onClick={() => navigate('/inquiry')}>
                        권한 요청하기
                    </Button>
                </div>
            </Alert>
        </Container>
    );
}

export default NoPermissionAlert; 